module.exports = __webpack_public_path__ + "img/bitrix.51586b69.svg";